import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centers-centers',
  templateUrl: './centers-centers.component.html',
  styleUrls: ['./centers-centers.component.scss']
})
export class CentersCentersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
